module.exports = __webpack_public_path__ + "img/WALK-PERFORMANCE-A-DROITE.5180d2ee.svg";